import {KpiItem} from '../common';

export enum ReportSectionEnum {
  TIMELINE_REPORT = 1,
  KPI_REPORT = 2,
  LOCAL_AREAS_REPORT = 3,
  MENTION_TIMELINE_REPORT = 4,
  EXPOSURE_KPI_REPORT = 5,
  EXPOSURE_PLATFORM_REPORT = 6,
  BEST_EXPOSURE_REPORT = 7,
  SEGMENTATION_INFLUENCER_OVERVIEW_REPORT = 8,
  SEGMENTATION_SEGMENT_REPORT = 9,
  SEGMENTATION_INDUSTRY_REPORT = 10,
  INSIGHT_OPPORTUNITY_REPORT = 11,
  INSIGHT_BENCHMARK_REPORT = 12,
  BEST_PERFORMING_INFLUENCER_REPORT = 16,
  ROI_REPORT = 17,
  INTERACTION_REPORT = 18,
  OONA_REPORT = 19
}
export class Report {
  is_default_report: boolean;
  id: number;
  name: string;
  sectionList: ReportSection[] = [];
}

export class ReportSection {
  id: number;
  // use when create or edit report
  section_id: number;

  position: number;
  section_height: number;
  section_preview_image: string;
  section_template: string;
  section_title: string;
}

export class ReportCreation {
  id: number;
  companyId: number;
  reportName: string;
  sections: ReportSection[] = [];
}

export class BenchmarkPerformanceReportDataPostItem {
  name: string;
  specificReach: number;
  benchmarkReach: number;
  percentComparison: number;
  status: string;
}

export class BenchmarkPerformanceReportData {
  menu: {
    nameLeft: string,
    nameRight: string
  };
  posts: Array<BenchmarkPerformanceReportDataPostItem>;
}

export class SegmentInfluencer {
  influencers: SegmentInfluencerSummarize;
  nationalities: SegmentCircleChartData[];
  platforms: SegmentLineChartData[];
}

export class SegmentLineChartData {
  color: string;
  name: string;
  value: number;
}

export class SegmentCircleChartData extends SegmentLineChartData {
  percent: number;
}

export class SegmentInfluencerSummarize extends SegmentCircleChartData {
  status: string;
}

export class InteractionReportItem {
  influencerId: number;
  url: string;
  urlHash: string;
  title: string;
  relativepath: string;
  imageUrl: string;
  influencerName: string;
  platform: number;
  audience: number;
  interaction: number;
  percentage: number;
  story: boolean;
  authorized: boolean;
}

export class InteractionReportData {
  posts: Array<InteractionReportItem>;
  kpi: {
    post: number;
    audience: number;
    interaction: number;
    share: number;
  };
  totalRows: number;
  pageNo: number;
}

export class BestPerformingInfluencer {
  engagement: number;
  id: number;
  impact: number;
  influencerId: number;
  influencerImage: string;
  country: any;
  influencerName: string;
  mention: number;
  platformBlogs: boolean;
  platformFacebook: boolean;
  platformInstagram: boolean;
  platformYoutube: boolean;
}

export class ChannelOpportunityItem {
  name: string;
  percent: number;
  value: number;
  text: string;
  verticalName: string;
}

export class KpiReport {
  description: string;
  name: string;
  percent: number;
  status: string;
  value: number;

  constructor(kpi: KpiItem) {
    this.name = kpi.name;
    this.percent = kpi.percent;
    this.status = kpi.status;
    this.value = kpi.value;
  }
}

/**
 * model for Segment Industries Report
 */
export class SegmentIndustry {
  pieChart: IndustryPieChart[];
  barChart: IndustryBarChart[];
}

export class IndustryBarChart {
  name: string;
  value: number;
}

export class IndustryPieChart extends IndustryBarChart {
  reach: number;
}



// WEBPACK FOOTER //
// ./src/models/measure/report.ts